import {useTranslation} from "react-i18next";
import Select from 'react-select';
import DatePicker, { registerLocale } from "react-datepicker";
import React, {useEffect, useState} from "react";
import classNames from 'classnames';

import "react-datepicker/dist/react-datepicker.css";

import uk from 'date-fns/locale/uk';
import useEventFilter from "./hooks/useEventFilter";
registerLocale('uk', uk);

export default function EventFilter({notifyChange}) {
    const { t } = useTranslation();
    const filterFormData = useEventFilter();
    const {types, cities, certificates, specialties, organizers, prices} = filterFormData;

    const initialFilterState = {
        type: types[0],
        hasPrice: prices[0],
        //speciality: specialties[0],
        certificate: certificates[0],
        city: cities[0],
        organizer: organizers[0],
        startDate: '',
        endDate: '',
    };

    const [filter, setFilter] = useState(initialFilterState);

    const [showFilter, setShowFilter] = useState(false);

    const onChange = dates => {
        const [start, end] = dates;
        setFilter({...filter, startDate: start, endDate: end});
    };
    const onSubmit = event => {
        event.preventDefault();
        setShowFilter(false);
        notifyChange({
            type: filter.type.value,
            hasPrice: filter.hasPrice.value,
            //speciality: filter.speciality.value,
            certificate: filter.certificate.value,
            city: filter.city.value,
            organizer: filter.organizer.value,
            startDate: filter.startDate,
            endDate: filter.endDate,
        })
    };

    return (
        <div className="container">
            { showFilter && <div className="overlay is-visible" onClick={() => {
                setShowFilter(false);
            }} />}
            <div className={classNames("js-sideBlock sideFilters", {open: showFilter})}>
                <div className="wrapper">
                    <div className="filter-list-form">
                        <button onClick={() => setShowFilter(!showFilter)} className={classNames("btn btn-show-sideBlock js-show-hide-sideBlock", {"close-btn": showFilter})}>
                            <span>{ t('conferences.filters.caption') }</span>
                            <div />
                        </button>
                        <form onSubmit={onSubmit}>
                            <div className="flex flex-start-items">
                                <div className="options-grid">
                                    <div>
                                        <label>{ t('conferences.filters.type') }</label>
                                        <div className="js-dropdown-select">
                                            <Select
                                                name="type"
                                                onChange={(selectedOption) => setFilter({...filter, type: selectedOption})}
                                                options={types}
                                                value={filter.type}
                                                defaultValue={types[0]}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <label>{ t('conferences.filters.price.caption') }</label>
                                        <div className="js-dropdown-select">
                                            <Select
                                                name="hasPrice"
                                                onChange={(selectedOption) => setFilter({...filter, hasPrice: selectedOption})}
                                                placeholder=""
                                                options={prices}
                                                value={filter.hasPrice}
                                                defaultValue={prices[0]}
                                            />
                                        </div>
                                    </div>
                                    { /* <div>
                                        <label>{ t('conferences.filters.specialty') }</label>
                                        <div className="js-dropdown-select-search">
                                            <Select
                                                name="speciality"
                                                onChange={(selectedOption) => setFilter({...filter, specialilty: selectedOption})}
                                                placeholder=""
                                                options={specialties}
                                                value={filter.specialilty}
                                                defaultValue={specialties[0]}
                                            />
                                        </div>
                                    </div> */ }
                                    <div>
                                        <label>{ t('conferences.filters.certification') }</label>
                                        <div className="js-dropdown-select">
                                            <Select
                                                name="certificate"
                                                onChange={(selectedOption) => setFilter({...filter, certificate: selectedOption})}
                                                placeholder=""
                                                options={certificates}
                                                value={filter.certificate}
                                                defaultValue={certificates[0]}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <label>{ t('conferences.filters.city') }</label>
                                        <div className="js-dropdown-select">
                                            <Select
                                                name="city"
                                                onChange={(selectedOption) => setFilter({...filter, city: selectedOption})}
                                                placeholder=""
                                                options={cities}
                                                value={filter.city}
                                                defaultValue={cities[0]}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <label>{ t('conferences.filters.organizer') }</label>
                                        <div className="js-dropdown-select">
                                            <Select
                                                name="organizer"
                                                onChange={(selectedOption) => setFilter({...filter, organizer: selectedOption})}
                                                placeholder=""
                                                options={organizers}
                                                value={filter.organizer}
                                                defaultValue={organizers[0]}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="calendar-container js-calendar-container">
                                    <DatePicker
                                        selected={filter.startDate}
                                        onChange={onChange}
                                        startDate={filter.startDate}
                                        endDate={filter.endDate}
                                        selectsRange
                                        monthsShown={2}
                                        locale={uk}
                                        inline
                                    />
                                    <input type="text" name="" value="" className="conference-field js-conference-calendar"/>
                                    <input type="text" name="date" value="" className="conference-field js-conference-date"/>
                                </div>
                            </div>
                            <div className="apply-filters">
                                <input type="submit" value={ t('conferences.filters.apply') }
                                       className="btn btn-apply js-apply-filters" />
                                <a onClick={(event) => {
                                    event.preventDefault();
                                    setFilter(initialFilterState);
                                    setShowFilter(false);
                                    notifyChange({
                                        type: initialFilterState.type.value,
                                        hasPrice: initialFilterState.hasPrice.value,
                                        speciality: initialFilterState.speciality.value,
                                        certificate: initialFilterState.certificate.value,
                                        city: initialFilterState.city.value,
                                        organizer: initialFilterState.organizer.value,
                                        startDate: initialFilterState.startDate,
                                        endDate: initialFilterState.endDate,
                                    })
                                }} className="clear-filters js-reset">{ t('conferences.filters.clear') }</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
